module.exports = __webpack_public_path__ + "img/15.8fcbbbb2.jpg";